define('LocationsTable.View', [
  'underscore',
  'SCView',
  'DateCalculations',
  'locations_table.tpl'
], function LocationsTableViewModule(_, SCViewComponent, DateCalculations, locationsTableTpl) {
  'use strict';

  var SCView = SCViewComponent.SCView;

  function LocationsTableView(options) {
    SCView.call(this, options);
    this.template = locationsTableTpl;
    this.pdp = options.pdp;
    this.model = options.model;
    this.environment = options.environment;
    this.setupListeners();
  }

  LocationsTableView.prototype = Object.create(SCView.prototype);

  _.extend(LocationsTableView.prototype, {
    constructor: LocationsTableView,

    destroy: function destroy() {
      this.unsetListeners();
    },

    setupListeners: function setupListeners() {
      var self = this;
      this.model.getLocations().on(
        'sync',
        function listenLocationsChange() {
          self.render();
        },
        this
      );
    },

    unsetListeners: function unsetListeners() {
      this.model.getLocations().off('sync', null, this);
    },

    getContext: function getContext() {
      var self = this;
      var model = this.model;
      var itemInfo = self.pdp.getItemInfo();
      var customTable = self.environment && self.environment.getConfig('locationShippingTimes.customTable');
      var newQuantityForOtherWarehouses = itemInfo && itemInfo.item && itemInfo.item.custitem_es_ds_other_warehouses || '';
      var isLoading = model.isLoading();
      var shouldShow = model.shouldShow();
      var isLoaded = !isLoading && shouldShow;
      var availLocations = model.getQuantityAvailableForLocations();
      var locSize = 0;
      availLocations.forEach(function (loc) {
        var locations = model.getLocations();
        var locationId = loc.internalid;
        var location = locations.findWhere({ id: locationId });
        if (location) {
          locSize++;
        }
      });

      if (newQuantityForOtherWarehouses && (locSize === 0 || availLocations.length === 0)) {
        locSize++;
      }

      if(locSize === 0) {
        shouldShow = false;
      }

      // Other Warehouses stock lives on a custom field, so when the item has no
      // Alberta/Ontario inventory model.shouldShow() is false. Drive visibility
      // from locSize (matched locations + the Other Warehouses row) instead.
      shouldShow = !isLoading && model.isLoggedIn() && locSize > 0;
      isLoaded = shouldShow;

      var context = {
        isLoading: isLoading,
        shouldShow: shouldShow,
        customTable: customTable
      };
      return _.extend(context, isLoaded ? this.getContextLoaded() : {});
    },

    getContextLoaded: function getContextLoaded() {
      var self = this;
      var model = self.model;
      var rows = _.map(
        model.getQuantityAvailableForLocations(),
        function mapQuantityAvailable(quantityAvailableForLocation) {
          return self.getContextForRow(quantityAvailableForLocation);
        }
      ).sort().reverse();
      rows.push(rows.splice(1, 1)[0]);
      rows = self.validateCustomField(rows);
      rows = _.sortBy(rows, 'id');
      return {
        hasLocations: rows.length > 0,
        locations: rows
      };
    },

    validateCustomField: function validateCustomField(rows) {
      var self = this;
      var newArrayOfLocations = [];
      var otherWareHousesLocationId = self.environment.getConfig('dealerSourceThemeHelper.otherWareHousesId');
      var itemInfo = self.pdp.getItemInfo();
      var item = itemInfo && itemInfo.item;
      var newQuantityForOtherWarehouses = item && item.custitem_es_ds_other_warehouses;
      var customLocation = null;
      _.each(rows, function (row) {
        if (row) {
          if (row.id === parseInt(otherWareHousesLocationId)) {
            customLocation = row;
          }
          newArrayOfLocations.push(row);
        }
      });
      if (!customLocation && newQuantityForOtherWarehouses) {
        newArrayOfLocations.push({
          cutOffTime: self.getCutOffTime(item),
          id: parseInt(otherWareHousesLocationId),
          name: 'Other Warehouses',
          quantityAvailable: newQuantityForOtherWarehouses,
          estimatedDaysToShip: item.custitem_uc_ow_est_days_ship || 'N/A'
        });
      }
      return newArrayOfLocations;
    },

    getCutOffTime: function getCutOffTime(itemInfo) {
      var cutOffTime = itemInfo.custitem_uc_ow_cut_off_time;
      var timeZone = itemInfo.custitem_uc_ow_time_zone;
      var zone = timeZone.indexOf('Eastern') > -1 ? 'ET' : 'MT';
      return cutOffTime + ' ' + zone;
    },

    getContextForRow: function getContextForRow(quantityAvailableForLocation) {
      var self = this;
      var model = self.model;
      var customTable = self.environment && self.environment.getConfig('locationShippingTimes.customTable');
      var otherWareHousesLocationId = self.environment.getConfig('dealerSourceThemeHelper.otherWareHousesId');
      var locations = model.getLocations();
      var name, cutOffTime;
      var wrongCutOffEst = 'EDT';
      var wrongCutOffMst = 'MDT';
      var minorOne = -1;
      var itemInfo = self.pdp.getItemInfo();
      var newQuantityForOtherWarehouses = itemInfo && itemInfo.item && itemInfo.item.custitem_es_ds_other_warehouses;
      var locationId = quantityAvailableForLocation.internalid;
      var quantityAvailable = quantityAvailableForLocation.quantityavailable;

      var location = locations.findWhere({ id: locationId });
      if (!location) {
        return;
      }
      if (parseInt(otherWareHousesLocationId) === locationId && newQuantityForOtherWarehouses >= 0) {
        quantityAvailable = newQuantityForOtherWarehouses;
      }
      var origianlName = location ? location.getName() : 'N/A';
      var nameToLoweCase = origianlName.toLowerCase();
      var estimatedShippingMin = location ? location.getShippingTimeDaysMinAttr() : null;
      var estimatedShippingMax = location ? location.getShippingTimeDaysMaxAttr() : null;
      var originalCutOffTime = location ? location.getCutOffTime() : 'N/A';
      var estimatedShippingTimeString = estimatedShippingMin
        ? estimatedShippingMin + (estimatedShippingMax ? '-' + estimatedShippingMax : '')
        : 'N/A';
      var cutOffTimeData = location ? location.getCutOffTimeData() : null;

      if (!customTable) {
        if (originalCutOffTime.indexOf(wrongCutOffEst) > minorOne) {
          cutOffTime = originalCutOffTime.split(wrongCutOffEst)[0] + 'ET';
        } else if (originalCutOffTime.indexOf(wrongCutOffMst) > minorOne) {
          cutOffTime = originalCutOffTime.split(wrongCutOffMst)[0] + 'MT';
        } else {
          cutOffTime = originalCutOffTime;
        }
      }else{
        cutOffTime = originalCutOffTime;
      }

      if (!customTable) {
        if (nameToLoweCase.indexOf('other warehouses') > minorOne) {
          name = 'Other Warehouses';
        } else if (nameToLoweCase.indexOf('ontario') > minorOne || 
          (location && location.attributes && location.attributes.name.toLowerCase().indexOf('ontario') > minorOne))
        {
          name = 'Toronto, Ontario';
        } else {
          name = 'Edmonton, Alberta';
        }
      } else {
        name = origianlName;
      }

      var estimatedDaysToShip = location.get('estimatedDaysToShip') || 'N/A';

      return {
        id: locationId,
        name: name,
        quantityAvailable: quantityAvailable,
        cutOffTime: cutOffTime,
        estimatedDaysToShip: estimatedDaysToShip,
        estimatedShippingTime: estimatedShippingTimeString,
        cutOffTimeData: cutOffTimeData,
        estimatedShippingTimeMin: estimatedShippingMin,
        customTable:customTable
      };
    },

    compareRowContexts: function compareRowContexts(row1, row2) {
      var minTime1 = row1.estimatedShippingTimeMin;
      var minTime2 = row2.estimatedShippingTimeMin;
      var timeComparison = DateCalculations.compareShippingTimes(minTime1, minTime2);
      if (timeComparison !== 0) {
        return timeComparison;
      }
      // if same shipping time, compare cutoff
      return DateCalculations.compareTimeOfDayToday(row1.cutOffTimeData, row2.cutOffTimeData);
    }
  });

  return LocationsTableView;
});
